import React from 'react'
import TreatmentList from './treatment/treatment_components/treatmentList'
import WebSidebar from './web_sidebar'
export default function Main() {


    return (
        <div>
            <WebSidebar />
            <TreatmentList />
        </div>

    )
}





